/** Spacing scale (px). Use via CSS var(--tra-space-*) or spacing[n]. */
export const spacing = {
  0: 0,
  1: 2,
  2: 4,
  3: 8,
  4: 12,
  5: 16,
  6: 20,
  7: 24,
  8: 32,
  9: 40,
  10: 48,
  11: 64,
  12: 80,
  13: 96,
};

export const spacingSemantic = {
  xs: spacing[1],
  sm: spacing[2],
  md: spacing[3],
  lg: spacing[5],
  xl: spacing[7],
  "2xl": spacing[8],
  "3xl": spacing[10],
  /** Visual Language v2 — between major sections (40px) */
  visualSection: spacing[9],
  /** Visual Language v2 — horizontal page gutter (24px shell margin) */
  visualGutter: spacing[7],
};
